import { render, staticRenderFns } from "./AccountCancel.vue?vue&type=template&id=01394d44"
import script from "./AccountCancel.vue?vue&type=script&lang=js"
export * from "./AccountCancel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports